// extracted by mini-css-extract-plugin
module.exports = {"copiedText":"clinical-portal-3__CopySessionIdButton__copiedText"};